import React from "react"
import Layout from "src/components/Layout"
import TAMIL_COURSES from "src/data/courses/tamil_courses_list"
import Card from "src/components/cards/Card"
import { Link } from "gatsby"

export default function TamilCourses() {
  const courses = TAMIL_COURSES

  return (
    <Layout>
      <div className="container" key={Math.random().toString()}>
        <h1 className="heading">Tamil Courses</h1>
        <div className="card_grid">
          {courses.map(course => (
            <Link to={course.slug} key={course.slug}>
              <Card>
                <h1 className="heading">{course.title}</h1>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  )
}
